import { TextContent, TextDataContent } from '../interfaces/ContentBlock';

export const parseTextContent = (textContent: TextDataContent): TextContent[] => {
  return Object.keys(textContent).map((k) => {
    const text = textContent[k].text?.();
    const type = textContent[k].type();

    const items =
      textContent[k].items && typeof textContent[k].items === 'object'
        ? Object.keys(textContent[k].items || {}).map((b) => textContent[k].items![b]())
        : [];

    return {
      text,
      items,
      type,
    };
  });
};
